<template>
<!-- 动态新闻 -->
    <div class="YinshiOffcialwebsiteNewsInfo">
        <div><el-button type="primary" size="small" @click="addNewsInfo">添加</el-button></div> 
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="id" label="id"></el-table-column>
            <el-table-column prop="coverImageUrl" label="封面图"></el-table-column>
            <el-table-column prop="introduce" label="简介" width="300"></el-table-column>
            <el-table-column prop="newsContent" label="新闻详情" width="400"></el-table-column>
            <el-table-column prop="newsDate" label="新闻日期" width="130"></el-table-column>
            <el-table-column prop="title" label="标题" ></el-table-column>
            <el-table-column prop="views" label="浏览量" width="80"></el-table-column>
            <el-table-column label="操作" width="170">
                <template slot-scope="scope" >
                    <el-button size="mini" @click="updataNewsInfo(scope.row)">编辑</el-button>&ensp;
                    <el-popconfirm title="确定要删除吗？" icon="el-icon-info" icon-color="red" @confirm="deleteNewsInfo(scope.row.id)">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <div class="block">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="10"
                    layout="sizes, prev, pager, next"
                    :total="count">
                </el-pagination>
            </div>
        </div>
        <el-dialog :title="title+'动态新闻信息'" :visible.sync="dialogFormVisible" class="personalInfo" width="29%">
            <div class="recruit">
                <el-form :model="operObj" ref="downloadObj">
                    <el-form-item label="标题" class="labelWidth">
                        <el-input v-model="operObj.title"></el-input>
                    </el-form-item>
                    <el-form-item label="封面图" class="labelWidth">
                        <el-input v-model="operObj.coverImageUrl" ></el-input>
                    </el-form-item>
                    <el-form-item label="简介" class="labelWidth">
                        <el-input v-model="operObj.introduce"></el-input>
                    </el-form-item>
                    <el-form-item label="新闻日期" class="labelWidth">
                        <el-date-picker
                            v-model="operObj.newsDate"
                            type="date"
                            placeholder="选择日期"
                            format="yyyy 年 MM 月 dd 日"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    
                    <el-form-item label="新闻详情" class="labelWidth">
                        <el-input v-model="operObj.newsContent" type="textarea"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="浏览量" class="labelWidth">
                        <el-input v-model="operObj.views" disabled></el-input>
                    </el-form-item> -->
                </el-form>
            </div>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitUpdate">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// listNews      查询动态新闻
// deleteNews    删除动态新闻
// saveNews      保存动态新闻
// updateNews    修改动态新闻
import { 
listNews,
deleteNews,
saveNews,
updateNews,} from '@/service'
export default {
    name: 'YinshiOffcialwebsiteNewsInfo',

    data() {
        return {
            // 分页
            pageObj:{
                page:1,
                pageSize:10,
            },
            count:0,
            // 动态新闻
            tableData: [],
            title:'',
            dialogFormVisible:false,
            // 要修改或者要增加
            operObj:{
                coverImageUrl:'',
                introduce:'',
                newsContent:'',
                newsDate:'',
                title:'',
                views:'',
                id:'',
            },
        };
    },

    mounted() {
        
    },
    methods: {
        // 每页多少条
        handleSizeChange(val){
            this.pageObj.pageSize = val
            this.selectNewsInfo()
        },
        // 页码
        handleCurrentChange(val){
            this.pageObj.page = val
            this.selectNewsInfo()
        },
        // 查询动态新闻列表
        async selectNewsInfo(){
            let res = await listNews({page:this.pageObj.page,pageSize:this.pageObj.pageSize});
            // 学历信息
            this.count = res.page.count
            this.tableData = res.data
        },
        // 删除
        async deleteNewsInfo(id){
            let res = await deleteNews(id);
            if(res.code == 200){
                this.$message({ message: '删除成功！', type: 'success' });
                this.selectNewsInfo()
            }else{
                this.$message({message: '删除失败！',type: 'error'});
            }
        },
        
        // 修改企业信息
        async updataNewsInfo(obj){
            this.dialogFormVisible = true
            Object.keys(obj).forEach(key1 => {
                Object.keys(this.operObj).forEach(key2 => {
                    if(key1 == key2){
                        this.operObj[key2] = obj[key1] 
                    }
                })
            })
            this.title = '修改'
        },
        // 新增
        addNewsInfo(){
            Object.keys(this.operObj).forEach(key => {
                this.operObj[key] = ''
            })
            this.title = '新增'
            this.dialogFormVisible = true

        },
        // 提交修改
        async submitUpdate(){
            let res;
            if(this.title == '新增'){
                res = await saveNews(this.operObj);
            }else{  //新增
                res = await updateNews(this.operObj);
            }
            if(res.code == 200){
                this.$message({ message: this.title+'成功！', type: 'success' });
                this.selectNewsInfo()
                this.dialogFormVisible = false
            }else{
                if(res.data){
                    this.$message({message: res.data+'！',type: 'error'});
                }else{
                    this.$message({message: this.title+''+res.msg+'！',type: 'error'});
                }
            }
        }
    },
    created(){
        this.$store.state.adminCurrentRouter = this.$route.path  //获取当前页面路由
        this.selectNewsInfo()
    }
};
</script>

<style lang="scss">
.YinshiOffcialwebsiteNewsInfo .personalInfo .recruit{
    .el-form-item__label{
        width: 70px !important;
    }
    .el-form-item__content,.el-input__inner{
        width: 360px !important;
    }
}
</style>
<style lang="scss" scoped>
// 分页
.pagination{
    padding: 50px 270px 30px 270px;
    text-align: center;
}
</style>